module.exports = __webpack_public_path__ + "img/22_Ileocecal-valve.88855c14.png";